import { useEffect, useState, useCallback, useMemo } from 'react';

export const usePaginationMUI = (
  fetchFunction,
  tipo,
  initPage = 0,
  perPage = 10,
  texto = ""
) => {
  const [dataSource, setDataSource] = useState([]);
  const [page, setPage] = useState(initPage + 1);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const offSet = useMemo(() => (page - 1) * perPage, [page, perPage]);

  // Reset page to 1 when perPage changes
  useEffect(() => {
    setPage(1);
  }, [perPage]);

  // Memoize the load function to prevent unnecessary re-renders
  const loadData = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await fetchFunction(perPage, offSet, texto);
      const result = await res.payload;
      setDataSource(result?.data?.data || []);
      setTotal(result?.data?.total || 0);
    } catch (error) {
      console.error('Error loading data:', error);
      setDataSource([]);
      setTotal(0);
    } finally {
      setIsLoading(false);
    }
  }, [fetchFunction, perPage, offSet, texto]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const handlePage = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  const refreshData = useCallback(() => {
    loadData();
  }, [loadData]);

  return { dataSource, total, handlePage, page, isLoading, refreshData };
};
